module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAYCAMAAAA1ddazAAAAOVBMVEUAAABmZmZmZmZmZmZmZmZnZ2dnZ2dmZmZmZmZnZ2dnZ2dnZ2dnZ2dqampmZmZmZmZpaWlsbGxmZmY1SNP+AAAAEnRSTlMA8Pvq5GAu7thnWlVIKrWrJyGllysLAAAAYUlEQVQoz53SSw6AIAwE0AoFUfE39z+s6cqN7Rhm+whp2pE3JbcqfhYAR8w4XS7Gesd8uZwA5N3j9Q9XjzfjeZS7MdL0mdZFEUWZs//pfOQB2Q/ZL7kPuS/rB+8X7yfr9wMfjQtJfrtPeAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/backIcon.png
// module id = 438
// module chunks = 0